function parseVariantMap (scriptEl) {
  if (!scriptEl?.textContent) return null
  try {
    return JSON.parse(scriptEl.textContent.trim())
  } catch {
    return null
  }
}

function getVariantRadiosVariants () {
  const radios = document.querySelector('variant-radios')
  const jsonEl = radios?.querySelector('script[type="application/json"]')
  if (!jsonEl?.textContent) return []
  try {
    return JSON.parse(jsonEl.textContent)
  } catch {
    return []
  }
}

function optionsFromUrlVariant (variants) {
  const params = new URLSearchParams(window.location.search)
  const vid = params.get('variant')
  if (!vid || !variants?.length) return []
  const match = variants.find(v => String(v.id) === vid)
  if (!match) return []
  const triple = [match.option1, match.option2, match.option3].map(o => o || '')
  while (triple.length < 3) triple.push('')
  return triple
}

function optionsFromRadios () {
  const rows = []
  document.querySelectorAll('variant-radios fieldset.variant-inputs').forEach(fs => {
    const checked = fs.querySelector('input.product-info__variant-radio:checked')
    rows.push(checked?.value || '')
  })
  return rows
}

function tripleFromVariant (v) {
  if (!v) return ['', '', '']
  return [v.option1, v.option2, v.option3].map(o => o || '')
}

function getSourceOptionTriple (variantMap, currentProductId) {
  const variants = getVariantRadiosVariants()
  let triple = optionsFromUrlVariant(variants)
  if (triple.some(Boolean)) {
    while (triple.length < 3) triple.push('')
    return triple
  }
  triple = optionsFromRadios()
  if (triple.some(Boolean)) {
    while (triple.length < 3) triple.push('')
    return triple
  }
  const vid = new URLSearchParams(window.location.search).get('variant')
  const pool = variantMap?.[String(currentProductId)]
  if (vid && pool?.length) {
    const match = pool.find(v => String(v.id) === vid)
    if (match) return tripleFromVariant(match)
  }
  while (triple.length < 3) triple.push('')
  return triple
}

function targetVariantFromSource (targetVariants, sourceTriple) {
  if (!targetVariants?.length || !sourceTriple?.length) return null
  const padded = [...sourceTriple]
  while (padded.length < 3) padded.push('')
  return targetVariants.find(tv => {
    for (let j = 1; j <= 3; j++) {
      const topt = tv[`option${j}`]
      if (!topt) continue
      const sopt = padded[j - 1]
      if (!sopt || sopt !== topt) return false
    }
    return true
  }) || null
}

function stripVariantQuery (href) {
  try {
    const u = new URL(href, window.location.origin)
    u.searchParams.delete('variant')
    const path = u.pathname + (u.search ? u.search : '')
    return path.startsWith('/') ? path : `/${path}`
  } catch {
    return href.split('?')[0]
  }
}

class LinkedModelSwitch extends HTMLElement {
  connectedCallback () {
    this.variantMap = parseVariantMap(this.querySelector('script[data-role="variant-map"]'))
    if (!this.variantMap) return
    this.boundPointerDown = this.onPointerDown.bind(this)
    this.addEventListener('pointerdown', this.boundPointerDown, true)
  }

  disconnectedCallback () {
    if (!this.boundPointerDown) return
    this.removeEventListener('pointerdown', this.boundPointerDown, true)
  }

  onPointerDown (e) {
    const link = e.target.closest?.('a[data-linked-product-id]')
    if (!link || !this.variantMap) return
    const pid = link.dataset.linkedProductId
    const targetVariants = this.variantMap[pid]
    if (!targetVariants?.length) return
    const sourceTriple = getSourceOptionTriple(this.variantMap, this.dataset.currentProductId)
    const matched = targetVariantFromSource(targetVariants, sourceTriple)
    const base = stripVariantQuery(link.getAttribute('href'))
    if (matched?.id) {
      link.setAttribute('href', `${base}?variant=${matched.id}`)
    } else {
      link.setAttribute('href', base)
    }
  }
}

if (!customElements.get('linked-model-switch')) {
  customElements.define('linked-model-switch', LinkedModelSwitch)
}
